import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connectModal } from "redux-modal";
import {
  Button,
  ButtonGroup,
  IconButton,
  FrameHeader,
  FrameFooter,
  DisplaySmall,
  RemoveSmall,
  spacing,
} from "@conserveit/blocks";
import { Trans } from "@lingui/macro";
import styled from "styled-components";
import Modal from "../_BETA/Modal";

export const CHANGE_PASSWORD_MODAL = "CHANGE_PASSWORD_MODAL";

const StyledModal = styled(Modal)`
  min-height: 600px;

  & .Modal-content {
    min-height: auto;
    max-height: none;
    height: auto;
    max-width: 50%;
  }
`;
const ModalBody = styled.div`
  margin: ${spacing.loose};
`;

const StyledButtonGroup = styled(ButtonGroup)`
  justify-content: right;
`;

const StyledFrameHeader = styled(FrameHeader)`
  display: flex;
  justify-content: space-between;
`;

class ChangePasswordModal extends PureComponent {
  static propTypes = {
    modalTitle: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    modalSubmit: PropTypes.func.isRequired,
    modalWorking: PropTypes.bool,
    pristine: PropTypes.bool,
    handleHide: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    modalWorking: false,
    pristine: false,
  };

  render() {
    const {
      modalTitle,
      modalSubmitText,
      modalSubmit,
      modalWorking,
      pristine,
      show,
      handleHide,
    } = this.props;

    return (
      <StyledModal isOpen={show} onRequestClose={handleHide}>
        <StyledFrameHeader>
          <DisplaySmall>{modalTitle}</DisplaySmall>
          <IconButton icon={<RemoveSmall />} onClick={handleHide} />
        </StyledFrameHeader>
        <ModalBody>{this.props.children}</ModalBody>

        <FrameFooter>
          <StyledButtonGroup tight>
            <Button onClick={handleHide} thin appearance="outline">
              <Trans id="modal.close">Close</Trans>
            </Button>
            <Button
              onClick={modalSubmit}
              thin
              additive
              disabled={modalWorking || pristine}
            >
              {modalSubmitText}
            </Button>
          </StyledButtonGroup>
        </FrameFooter>
      </StyledModal>
    );
  }
}

const ConnectedChangePasswordModal = connectModal({
  name: CHANGE_PASSWORD_MODAL,
  getModalState: (state) => state.betaModal,
})(ChangePasswordModal);

export default ConnectedChangePasswordModal;
